// extracted by mini-css-extract-plugin
export default {"root":"Feature_root__DV+uD","variant2":"Feature_variant2__s61zb","show":"Feature_show__fssUG","movein":"Feature_movein__njGZ0"};